import { loadGtm, settingUCUIDomains } from "./helpers/utils";
import { useSiteContext } from "context/SiteProvider";
import React, { useEffect } from "react";

let gtmEventInit = false;

const CookieBanner = () => {
  const { state, dispatch } = useSiteContext();

  useEffect(() => {
    settingUCUIDomains();
    if (!gtmEventInit) {
      loadGtm(process.env.GATSBY_GTM);
      gtmEventInit = true;
    }
    if (dispatch) {
      dispatch({ type: "write_script_gtm", payload: true });
    }
  }, [dispatch]);

  return <div />;
};

export default CookieBanner;
